/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Paper Airplane (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgPaperAirplane = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m42 49 9 2-9-18-9 18zm0 0v-8"
    />
  </svg>
);
export default SvgPaperAirplane;
